import React from 'react';
import { TextLink } from '../../../commonTypes/links';
import colors from '../../../helpers/colors';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import { BottomNavBarItem, BottomNavBarLink, BottomNavBarWrapper } from './styles';

export type FooterNavBarProps = {
  links: TextLink[];
} & ComponentProps;

const FooterNavBar: React.FC<FooterNavBarProps> = ({ links, ...props }) => {
  return (
    <div {...componentProps(props)}>
      <BottomNavBarWrapper>
        {links &&
          links.length > 0 &&
          links.map((link) => (
            <BottomNavBarItem key={link.text}>
              <BottomNavBarLink
                href={link.url}
                color={colors.neutral08}
                openInNewTab={link.openInNewTab}>
                {link.text}
              </BottomNavBarLink>
            </BottomNavBarItem>
          ))}
      </BottomNavBarWrapper>
    </div>
  );
};
export default applyComponentTheme(FooterNavBar, 'FooterNavBar');
